import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls.ts';

import { getAppliedFilter, getFilterValues } from '../sbSharedRefineMenuHelpers.ts';

// Constants
import { SbSharedRefineMenuRadioSelect } from '../../SbSharedRefineMenu/SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect.jsx';

// Constants
import { NET_PRICE_TRADE_DISCOUNT } from '../../SbSharedRefineMenu/sbSharedRefineMenuConstants.ts';

import { type SbSharedRefineMenuNetPriceTradeDiscount_itemSearch$key } from './__generated__/SbSharedRefineMenuNetPriceTradeDiscount_itemSearch.graphql.ts';

import styles from './SbSharedRefineMenuNetPriceTradeDiscount.scss';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuNetPriceTradeDiscount_itemSearch on ItemSearchQueryConnection {
        displayUriRef
        filters {
            name
            localizedFilterName
            values {
                displayName
                urlLabel
                count
                linkReference
                linkable
            }
        }
        appliedFilters {
            name
            values {
                linkReference
                urlLabel
            }
        }
        searchResultData {
            vectorResultCount
        }
    }
`;

type Props = {
    itemSearch: SbSharedRefineMenuNetPriceTradeDiscount_itemSearch$key;
    trackingOptions?: Record<string, unknown>;
};

export const SbSharedRefineMenuNetPriceTradeDiscount: FC<Props> = ({
    itemSearch: itemSearchRef,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { displayUriRef } = itemSearch;
    const filters = (itemSearch?.filters || []).filter(filterNulls);
    const appliedFilters = (itemSearch?.appliedFilters || []).filter(filterNulls);
    const hasVectorSearchResults = !!itemSearch?.searchResultData?.vectorResultCount;
    const valuesToShow = getFilterValues(filters, NET_PRICE_TRADE_DISCOUNT);
    if (valuesToShow.length === 0) {
        return null;
    }
    const localizedFilterName = getAppliedFilter(
        filters,
        NET_PRICE_TRADE_DISCOUNT
    )?.localizedFilterName;
    const appliedFilterValues = [...getFilterValues(appliedFilters, NET_PRICE_TRADE_DISCOUNT)];

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>{localizedFilterName}</div>
            <SbSharedRefineMenuRadioSelect
                filterName={NET_PRICE_TRADE_DISCOUNT}
                valuesToShow={valuesToShow}
                appliedFilterValues={appliedFilterValues}
                displayUriRef={displayUriRef}
                canBeDismissed
                trackInputIndex
                trackingOptions={trackingOptions}
                hasVectorSearchResults={hasVectorSearchResults}
            />
        </div>
    );
};
